import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const WrapperName = styled.h1`
  font-weight: 700;
  font-size: 24px;
  line-height: 32px;
  color: #000f37;
  text-transform: capitalize;

  & > span {
    display: block;
    font-weight: 700;
    font-size: 14px;
    line-height: 20px;
    color: #000f37;
  }
`;

export const WrapperCards = styled.div`
  display: grid;
  grid-template-rows: repeat(5, calc(100% / 5));
  border-radius: 8px;
  border: 1px solid #7a959f;
  background-color: #ffffff;
  box-shadow: 0 2px 4px 0 #eaeef1;
`;

export const WrapperCard = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  border-bottom: 1px solid #7a959f;
  padding: 12px;
  gap: 8px;

  @media (max-width: 767px) {
    flex-direction: column;
    gap: 0;
  }

  @media (min-width: 768px) {
    padding: 12px 0 12px 12px;
  }

  > h4 {
    font-weight: 700;
    font-size: 14px;
    line-height: 20px;
    color: #161d1f;

    @media (min-width: 768px) {
      width: 136px;
    }
  }

  > span {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #4f6168;
  }

  &:last-child {
    border-right: none;
    border-bottom: none;
  }

  @media (max-width: 640px) {
    border-right: none;
    border-bottom: 1px solid #7a959f;
  }
`;
